/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { COLORS } from "../../assets/utils/enums/colors";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import AppLayout from "../../components/layout/app/layout";
import {
  LittleHeadline,
  LittleSubHeadline,
  LittleText,
  NotificationText,
} from "../../components/typography";
import { Button } from "../../components/ui/button";
import { LinkText } from "../../components/ui/error-text";
import Headline from "../../components/ui/headline";
import StatisticBlock, {
  DataStatisticProps,
} from "../../components/ui/statistics-block";
import { ItemMainBlock } from "../project/details";
import basketIcon from "../../assets/images/icons/basket-icon.svg";
import pieIcon from "../../assets/images/icons/pie-one-icon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";
import {
  TypeClientEnum,
  typeClientObj,
} from "../../assets/utils/enums/project";
import { ProjectRow } from "../../assets/utils/table-types";
import getData from "../../api/project-request";
import {
  API_URL_COMPANY,
  API_URL_CONTACT,
  API_URL_PROJECT,
} from "../../constants";
import toast from "react-hot-toast";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { currencies } from "../../assets/utils/data/items";
import clientIcon from "../../assets/images/icons/user-filled-icon.svg";
import DataTable from "../../components/ui/table";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import { deleteArrFunc } from "../../assets/utils/request-function";
import { ButtonSpan } from "../company/details";
import { ModalWindowType } from "../../components/ui/modal-window";
import { ActionsEnum } from "../../assets/utils/enums/settings";
import { getItemsCountTable } from "../../assets/utils/pluralize-elements";

export default function DetailsClientPage() {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { period } = useStatisticPeriod();
  const [fullName, setFullName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [contactEmail, setContactEmail] = useState<string>();
  const [contactFullname, setContactFullname] = useState<string>();
  const [type, setType] = useState<TypeClientEnum>(
    TypeClientEnum.POTENTIAL_CLIENT
  );
  const [projects, setProjects] = useState<ProjectRow[]>([]);
  const [projStatistic, setProjStatistic] = useState<DataStatisticProps[]>([]);
  const [finStatistic, setFinStatistic] = useState<DataStatisticProps[]>([]);
  const [saleStatistic, setSaleStatistic] = useState<DataStatisticProps[]>([]);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);

  const [modalWindowSettings, setModalWindowSettings] =
    useState<ModalWindowType>({
      isOpen: false,
      onConfirm: () => { },
      onCancel: () => { },
    });

  const getProjects = async () => {
    setIsLoading(true);
    try {
      const data = await getData(
        `${API_URL_CONTACT}/get-projects-by-client?clientId=${id}`
      );
      if (Array.isArray(data)) {
        setProjects(data);
      } else {
        setProjects([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setProjects([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const data = await getData(
          `${API_URL_CONTACT}/get-client-by-id?id=${id}`
        );
        if (!data) return;

        setFullName(data.fullName);
        setType(
          (data.customerType as TypeClientEnum) ||
          TypeClientEnum.POTENTIAL_CLIENT
        );
        setPhone(data.phone || "—");
        setEmail(data.email || "—");
        setCompany(data.companyName || "—");
        setContactEmail(data.responsibleEmail);
        setContactFullname(data.responsibleFullName || "Представника немає. ");
      } catch (e) {
        console.error("Error loading company:", e);
        toast((t) => (
          <CustomToast
            t={t}
            text={"Не вдалося завантажити дані клієнта"}
            type={ToastTypeEnum.ERROR}
          />
        ));
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
    getProjects();
  }, [id]);

  useEffect(() => {
    getProjects();
    setIsDeleted(false);
  }, [isDeleted]);

  useEffect(() => {
    const getStatisticProject = async () => {
      const data = await getData(
        `${API_URL_CONTACT}/projects-summary?contactId=${id}&period=${period}`
      );

      setProjStatistic([
        {
          title: "Всі проєкти",
          value: data.all,
          percent: "",
        },
        {
          title: "Активні",
          value: data.active,
          percent: ``,
        },
        {
          title: "Виконані",
          value: data.completed,
          percent: ``,
        },
      ]);
    };

    const getStatisticFinance = async () => {
      setIsLoading(true);
      const data = await getData(
        `${API_URL_CONTACT}/finance-summary?contactId=${id}&period=${period}&currency=${currencies[1].code}`
      );

      setFinStatistic([
        {
          title: "Надходження",
          value: data.formattedIncomes || "0",
          percent: data.incomesChangePercent,
        },
        {
          title: "Витрати",
          value: data.formattedExpenses || "0",
          percent: data.expensesChangePercent,
        },
      ]);
    };

    const getStatisticSales = async () => {
      setIsLoading(true);
      const data = await getData(
        `${API_URL_COMPANY}/${id}/sales-summary?period=${period}`
      );

      setSaleStatistic([
        {
          title: "Всі продажі",
          value: data.totalSales || "0",
          percent: "",
        },
        {
          title: "У процесі",
          value: data.inProgressSales || "0",
          percent: "",
        },
        {
          title: "Завершені",
          value: data.completedSales || "0",
          percent: "",
        },
      ]);
    };

    setIsLoading(true);
    setTimeout(() => {
      getStatisticProject();
      //getStatisticSales();
      getStatisticFinance();
      setIsLoading(false);
    }, 100);
  }, [period]);

  return (
    <AppLayout
      className="d-flex flex-column align-items-center gap-2"
      blockType="details-project"
      loaderState={isLoading}
      modalWindow={modalWindowSettings}
    >
      <Headline
        headline={HeadlineTypeEnum.CLIENTS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Клієнтів"
        btn_link="/clients/main"
        isEdit={false}
      />
      <BodyDiv
        data-class="detail-main-block"
        className="justify-content-between flex-row w-100"
      >
        <div className="d-flex flex-column w-100 gap-3">
          <div className="d-flex align-items-center justify-content-between">
            <span className="d-flex align-items-center gap-3">
              <Button
                bgcolor={COLORS.main2}
                txtcolor={COLORS.white}
                brcolor={"transparent"}
                width="auto"
                className="center-btn"
                brradius="12px"
                type="large"
                onClick={() => { }}
              >
                <img
                  src={clientIcon}
                  className="object-fit-none"
                  alt="company-icon"
                />
              </Button>
              <LittleHeadline>{fullName}</LittleHeadline>
            </span>
            <Button
              bgcolor={typeClientObj[type].bgColor}
              txtcolor={typeClientObj[type].txColor}
              brcolor={"transparent"}
              width="auto"
              className="center-btn"
              brradius="12px"
              type="small"
              onClick={() => { }}
            >
              <LittleText>{type}</LittleText>
            </Button>
          </div>
          <span className="w-100 d-flex flex-wrap column-gap-4 row-gap-2">
            <ItemMainBlock>
              <NotificationText>Номер телефону</NotificationText>
              <LittleSubHeadline>{phone}</LittleSubHeadline>
            </ItemMainBlock>
            <ItemMainBlock>
              <NotificationText>Електронна пошта</NotificationText>
              <LinkText mainText={email} addText={email} />
            </ItemMainBlock>
            <ItemMainBlock>
              <NotificationText>Компанія</NotificationText>
              <LittleSubHeadline>{company}</LittleSubHeadline>
            </ItemMainBlock>
          </span>
          <span className="w-100 d-flex gap-4">
            <ItemMainBlock>
              <NotificationText>Відповідальний контакт</NotificationText>
              <LinkText
                attribute={"row"}
                mainText={contactFullname!}
                addText={contactEmail!}
              />
            </ItemMainBlock>
          </span>
        </div>

        <ButtonSpan>
          <Button
            bgcolor={COLORS.secondary1}
            txtcolor={COLORS["light-gray"]}
            brcolor={"transparent"}
            width="100%"
            className="center-btn"
            brradius="12px"
            type="small"
            onClick={() => {
              navigate(`/clients/update/${id}`);
            }}
          >
            <LittleText>Редагувати дані</LittleText>
          </Button>
          <Button
            bgcolor={COLORS.warning}
            txtcolor={COLORS["light-gray"]}
            brcolor={"transparent"}
            width="100%"
            className="center-btn"
            brradius="12px"
            type="small"
            onClick={() => {
              setModalWindowSettings({
                isOpen: true,
                onConfirm: () => {
                  if (!id) return;
                  deleteArrFunc(
                    [Number.parseInt(id)],
                    `${API_URL_CONTACT}/delete-client`,
                    setIsDeleted
                  );
                  setTimeout(() => {
                    setModalWindowSettings((prev) => ({
                      ...prev,
                      isOpen: false,
                    }));
                    navigate("/clients/main");
                  }, 100);
                },
                onCancel: () =>
                  setModalWindowSettings((prev) => ({
                    ...prev,
                    isOpen: false,
                  })),
                action: ActionsEnum.DELETE,
              });
            }}
          >
            <LittleText>Видалити клієнта</LittleText>
          </Button>
        </ButtonSpan>
      </BodyDiv>
      <div data-class="statistics-block" className="align-items-center w-100">
        <StatisticBlock
          iconColor={COLORS.secondary1}
          iconUrl={basketIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={projStatistic}
        />
        <StatisticBlock
          iconColor={COLORS.blue}
          iconUrl={pieIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={finStatistic}
        />
      </div>
      <DataTable
        table={tableColumnType[TableTypeEnum.PROJECTS]}
        data={projects}
        deleteArrFunc={(queryArr) =>
          deleteArrFunc(queryArr, `${API_URL_PROJECT}/archive`, setIsDeleted)
        }
      />
      {/* <DataTable
        table={tableColumnType[TableTypeEnum.COMPANY_EMPLOYEES]}
        data={employeesData}
        itemsCount={4}
      /> */}
    </AppLayout>
  );
}
